import React, { useState, useEffect, useMemo } from "react";
import {
  getAllAdmin,
  cleanAll,
  setBelogs,
  setDone,
  editTal,
  edit,
  fetchScheduledTasks,
  deleteScheduledTask,
  deleteOldScheduledTasks,
  updateScheduledTask,
} from "../../store/reducers/todosReducer";
import { toast } from "react-toastify";
import FilledLoading from "../common/loader/FilledLoading";
import OpacityLoading from "../common/loader/OpacityLoading";
import { useSelector, useDispatch } from "react-redux";
import ClientRoutes from "../../navigation/Routes";
import YesNoModal from "../common/modals/YesNoModal";
import {
  BoldFont,
  FlexRowBetween,
  GenericDiv,
  Input,
  ListHolder,
  MediumFont,
  TextWithPic,
  TodoCard,
} from "../common/Style";
import ToolsOptions from "../user/ToolsOptions";
import GenericModal from "../common/modals/GenericModal";
import { useHistory } from "react-router-dom";
import LogoutSpecipic from "../common/LogOut/LogoutSpecipic";
import tools from "../../assets/common/menu.svg";
import logout from "../../assets/common/logout.svg";
import sms from "../../assets/common/sms.svg";
import whatsapp from "../../assets/common/whatsapp.svg";
import refresh from "../../assets/common/refresh.svg";
import BottomMenu from "../common/others/BottomMenu";
import Switcher from "../common/switcher/Switcher";
import { dateFormat, days } from "../common/others/Functions";
import {
  countNotAnswered,
  getPhoneNumber,
  sendSms,
  sendSmsScheduled,
  sendWhatsapp,
} from "../../store/reducers/dataReducer";
import CopyText from "../common/others/CopyText";
import { editUserFirstCall } from "../../store/reducers/userReducer";
import TalsTodos from "./TalsTodos";
import FilterBar from "../common/others/FilterBar";
import { post } from "../../store/api/http";
import ServerRoutes from "../../store/api/routes";

const dict = {
  הודעה: "ac",
  ווצאפ: "ac",
  שיחה: "ac",
  קדם: "kdam",
  תזכורת: "reminder",
  תודה: "thank",
  ערב: "evening",
};

const scheduleTitleDict = {
  הודעה: "ac",
  ווצאפ: "ac",
  שיחה: "ac",
  קדם: "kdam",
  תזכורת: "reminder",
  תודה: "thank",
  ערב: "reminder",
};

const getTaskDateStr = (executionDate) => {
  if (!executionDate) return "";
  const s =
    typeof executionDate === "string"
      ? executionDate
      : executionDate.toISOString?.() || "";
  return s.slice(0, 10);
};

const toIsraelHHmm = (dateStrOrDate) => {
  const d = new Date(dateStrOrDate);
  return d.toLocaleTimeString("he-IL", {
    timeZone: "Asia/Jerusalem",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};

const getDefaultScheduleTime = () => {
  const tenMinLater = new Date(Date.now() + 10 * 60 * 1000);
  return tenMinLater.toLocaleTimeString("he-IL", {
    timeZone: "Asia/Jerusalem",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};

const getMinScheduleTime = (taskDateStr) => {
  const today = new Date().toLocaleDateString("en-CA", {
    timeZone: "Asia/Jerusalem",
  });
  if (taskDateStr !== today) return "00:00";
  const tenMinLater = new Date(Date.now() + 10 * 60 * 1000);
  return tenMinLater.toLocaleTimeString("he-IL", {
    timeZone: "Asia/Jerusalem",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};

const isTimeValidForSchedule = (dateStr, timeStr) => {
  const candidateMs = new Date(dateStr + "T" + timeStr + ":00+02:00").getTime();
  const minAllowedMs = Date.now() + 5 * 60 * 1000;
  return candidateMs > minAllowedMs;
};

const isTaskDatePassed = (executionDate) => {
  if (!executionDate) return true;
  const taskDateStr =
    typeof executionDate === "string"
      ? executionDate.slice(0, 10)
      : new Date(executionDate).toISOString().slice(0, 10);
  const today = new Date().toISOString().slice(0, 10);
  return taskDateStr < today;
};

const AdminTodos = () => {
  let categories = [
    { id: "הודעה", name: "הודעה" },
    { id: "ווצאפ", name: "ווצאפ" },
    { id: "תזכורת", name: "תזכורת" },
    { id: "תודה", name: "תודה" },
    { id: "ערב", name: "ערב" },
    { id: "שיחה", name: "שיחה" },
    { id: "שיחה ראשונה", name: "שיחה ראשונה" },
    { id: "", name: "" },
  ];
  const dispatch = useDispatch();
  const [showLoading, setShowLoading] = useState(false);
  // const [tizmunTime, setTizmunTime] = useState("2025-06-15T14:35:00");
  const [tizmunTime, setTizmunTime] = useState("");

  const [firstCall, setFirstCall] = useState(false);
  const { dataLoading } = useSelector((state) => state.dataReducer);
  const { todos } = useSelector((state) => state.todosReducer);
  let history = useHistory();
  const [showLogout, setShowLogout] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [showTals, setShowTals] = useState(false);
  const [category, setCategory] = useState("שיחה ראשונה");
  const [tizmun, setTizmun] = useState(false);
  const [scheduledTasks, setScheduledTasks] = useState([]);
  const [loadingScheduled, setLoadingScheduled] = useState(false);
  const [showScheduledModal, setShowScheduledModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [showBulkDeleteModal, setShowBulkDeleteModal] = useState(false);
  const [bulkDeleteDate, setBulkDeleteDate] = useState("");
  const [showEditModal, setShowEditModal] = useState(false);
  const [editTarget, setEditTarget] = useState(null);
  const [editScheduledTime, setEditScheduledTime] = useState("");
  const [scheduleModalTodo, setScheduleModalTodo] = useState(null);
  const [scheduleTime, setScheduleTime] = useState("");
  const [scheduleAlternatives, setScheduleAlternatives] = useState(null);
  const [cancelScheduleTodo, setCancelScheduleTodo] = useState(null);
  const [scheduleLoading, setScheduleLoading] = useState(false);
  const [schedulingTodoId, setSchedulingTodoId] = useState(null);
  const [showOccupiedSlotsModal, setShowOccupiedSlotsModal] = useState(false);
  const [occupiedSlots0809, setOccupiedSlots0809] = useState([]);
  const [loadingOccupiedSlots, setLoadingOccupiedSlots] = useState(false);

  const setNow = () => {
    const now = new Date();
    const hhmm = now.toLocaleTimeString("en-GB", {
      timeZone: "Asia/Jerusalem",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
    setTizmunTime(hhmm);
  };

  // const setNow = () => {
  //   const now = new Date();
  //   now.setSeconds(0);
  //   now.setMilliseconds(0);

  //   const tzDate = new Intl.DateTimeFormat("sv-SE", {
  //     timeZone: "Asia/Jerusalem",
  //     hour12: false,
  //     year: "numeric",
  //     month: "2-digit",
  //     day: "2-digit",
  //     hour: "2-digit",
  //     minute: "2-digit",
  //   }).format(now);

  //   const formatted = tzDate.replace(" ", "T"); // תוצאה בסגנון ISO
  //   setTizmunTime(formatted);
  // };

  const setNow2 = () => {
    const now = new Date();
    now.setSeconds(0);
    now.setMilliseconds(0);
    setEditScheduledTime(
      new Date(now.getTime() - now.getTimezoneOffset() * 60000)
        .toISOString()
        .slice(0, 19),
    );
  };

  const addMinutes = (m) => {
    if (!tizmunTime || !tizmunTime.includes(":")) return;
    const [h, min] = tizmunTime.split(":").map(Number);
    const totalM = (h * 60 + min + m + 24 * 60) % (24 * 60);
    const newH = Math.floor(totalM / 60);
    const newMin = totalM % 60;
    setTizmunTime(
      `${String(newH).padStart(2, "0")}:${String(newMin).padStart(2, "0")}`,
    );
  };

  const handleGetAll = () => {
    setShowLoading(true);
    dispatch(getAllAdmin()).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      setShowLoading(false);
    });
  };

  const handleSetFirstCall = () => {
    setFirstCall(null);
    setShowLoading(true);
    dispatch(
      editUserFirstCall(firstCall.id, {
        restRecordsAtFirstCall: firstCall.restRecordsAtFirstCall,
      }),
    ).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      else toast.success("הפעולה בוצעה בהצלחה!!");
      setShowLoading(false);
    });
  };

  const handleEditTal = () => {
    setFirstCall(null);
    setShowLoading(true);
    dispatch(
      editTal(firstCall.id, {
        restRecordsAtFirstCall: firstCall.restRecordsAtFirstCall,
      }),
    ).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      else toast.success("הפעולה בוצעה בהצלחה!!");
      setShowLoading(false);
    });
  };

  const handleCountNotAnswered = (uid) => {
    setShowLoading(true);
    dispatch(countNotAnswered({ uid })).then((res) => {
      // let f = ["jpeg", "png", "gif", "webp", "jpg"].some((opt) =>
      //   res.payload.pic
      //     .split(".")
      //     [res.payload.pic.split(".").length - 1].includes(opt)
      // );

      if (res.payload?.error) toast.error(res.payload?.error);
      else {
        let f = res.payload.mikdama;
        let pro = res.payload.producer;
        let pay = (
          parseFloat(res.payload.deal) * parseFloat(res.payload.records)
        ).toFixed(2);
        toast.info(
          <div>
            <FlexRowBetween>
              {category == "שיחה ראשונה" ? (
                <div>{dateFormat(res.payload.date)}</div>
              ) : (
                <div>{res.payload.paybox == "" ? "no" : "yes"}</div>
              )}
              {(pro == "CallUp" ||
                pro == "LetMeSit" ||
                pro == "BeSimple" ||
                pro == "Let_Me_Sit" ||
                pro == "אל על") &&
              f == 0 &&
              res.payload.paybox == "" &&
              res.payload.isPaid == false ? (
                <CopyText
                  marginLeft={"5px"}
                  dataToCopy={`לקוח יקר, יצאנו לדרך עם אישורי ההגעה! 💪\n\nנכון לעכשיו יש ${res.payload.records} רשומות לתשלום כפול ${res.payload.deal}₪ לרשומה יוצא ${pay}₪\nאנא כתבו לנו איך נוח לכם להסדיר תשלום - ביט או העברה ונכתוב לכם לאן להעביר\nאנא לא להעביר ביט למספר זה כי זה המספר של המוקד\nבמידה ובמהלך הדרך תוסיפו אורחים חדשים או תערכו מספר טלפון לאורח (נחשב כמו רשומה חדשה) בסיום התהליך נגבה את ההפרש הקטן הנ״ל\n\n*יש להסדיר תשלום בהקדם למען המשך פעילות 🙏*`}
                  text={"תשלום"}
                />
              ) : null}
            </FlexRowBetween>

            <FlexRowBetween style={{ marginTop: "10px" }}>
              {/* <div style={{ border: "1px solid black" }}>
                {f ? "ppp" : "xxx"}
              </div> */}
              <div>{res.payload.records}</div>
              <div
                onContextMenu={() => {
                  setFirstCall({
                    id: uid,
                    restRecordsAtFirstCall:
                      res.payload.amount + 10 - (res.payload.amount % 10),
                  });
                }}
              >
                {res.payload.amount}
              </div>
              <CopyText
                marginLeft={"5px"}
                dataToCopy={`${res.payload.phone}`}
                text={res.payload.phone}
              />
            </FlexRowBetween>
          </div>,
        );
      }

      setShowLoading(false);
    });
  };

  const handleSendSms = (uid, title, executionDate) => {
    setShowLoading(true);
    dispatch(sendSms({ uid, title: dict[title], executionDate })).then(
      (res) => {
        if (res.payload?.error) toast.error(res.payload?.error);
        else toast.success("הפעולה בוצעה בהצלחה");
        setShowLoading(false);
      },
    );
  };

  const handleSendSmsAndWhatsappScheduled = (
    uid,
    title,
    taskExecutionDate,
    platform = "sms",
  ) => {
    const dateStr = getTaskDateStr(taskExecutionDate);
    const timeStr =
      tizmunTime && tizmunTime.length >= 5
        ? tizmunTime.slice(0, 5)
        : tizmunTime && tizmunTime.includes(":")
          ? tizmunTime.padEnd(5, "0")
          : "";
    if (!dateStr || !timeStr) {
      toast.warning("יש לבחור שעה בשדה התזמון");
      return;
    }
    const [y, mo, d] = dateStr.split("-").map(Number);
    const [h, min] = timeStr.split(":").map(Number);
    const localScheduled = new Date(y, mo - 1, d, h, min, 0, 0);
    const executionDateForApi = localScheduled.toISOString();
    setShowLoading(true);
    dispatch(
      sendSmsScheduled({
        uid,
        title: dict[title],
        executionDate: executionDateForApi,
        platform,
      }),
    ).then((res) => {
      setShowLoading(false);
      if (res?.status === 409 || res?.error?.status === 409) {
        const body = res?.data ?? res?.error;
        const alternatives =
          body?.data?.alternatives ?? body?.alternatives ?? [];
        toast.warning(
          alternatives.length
            ? `הדקה תפוסה. שעות פנויות: ${alternatives.join(", ")}`
            : "הדקה תפוסה",
        );
        return;
      }
      if (res?.error)
        toast.error(res.error?.message || res.error || "שגיאה בתזמון");
      else toast.success("הפעולה בוצעה בהצלחה");
    });
  };

  const handleGetIsPaid = (uid) => {
    setShowLoading(true);
    dispatch(getPhoneNumber({ uid })).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      else
        toast.info(
          <FlexRowBetween>
            <div>{res.payload.isPaid ? "שולם" : "לא שולם"}</div>
            <a
              target="_blank"
              rel="noreferrer"
              href={`https://wa.me/972${res.payload.phone}/?text=לקוח יקר זו הודעה אוטומטית. תהליך וידוא ההגעה הסתיים ועליך להסדיר תשלום. לשם כך יש להיכנס למערכת, תפריט, לו״ז, לבחור ב״הסדרת תשלום״ ולעקוב אחר ההוראות`}
            >
              <img src={whatsapp} alt={"whatsapp"} style={{ width: "31px" }} />
            </a>
            <CopyText
              marginLeft={"5px"}
              dataToCopy={res.payload.phone}
              text={res.payload.phone}
            />
          </FlexRowBetween>,
        );
      setShowLoading(false);
    });
  };
  const handleCheck1 = (uid) => {
    setShowLoading(true);
    dispatch(getPhoneNumber({ uid })).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      else
        toast.info(
          <FlexRowBetween>
            <a
              target="_blank"
              rel="noreferrer"
              href={`https://wa.me/972${res.payload.phone}/?text=לקוח יקר, אנא כנס למערכת, תפריט, לו״ז, ולחץ על המשימה שיש להיום ופעל בהתאם`}
            >
              <img src={whatsapp} alt={"whatsapp"} style={{ width: "31px" }} />
            </a>
            <CopyText
              marginLeft={"5px"}
              dataToCopy={res.payload.phone}
              text={res.payload.phone}
            />
          </FlexRowBetween>,
        );
      setShowLoading(false);
    });
  };

  const handleSendWhatsapp = (uid, title, executionDate) => {
    setShowLoading(true);
    dispatch(sendWhatsapp({ uid, title: dict[title], executionDate })).then(
      (res) => {
        if (res.payload?.error) toast.error(res.payload?.error);
        else toast.success("הפעולה בוצעה בהצלחה");
        setShowLoading(false);
      },
    );
  };

  const handleSetBelogs = async (id, belongs) => {
    const body = { belongs };
    dispatch(setBelogs(id, body)).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
      } else toast.error(res.payload?.error);
    });
  };

  const checkScheduleAvailability = async (
    todo,
    chosenTimeStr,
    platform = "sms",
  ) => {
    const dateStr = getTaskDateStr(todo.executionDate);
    if (!dateStr) return { free: false, alternatives: [] };
    const result = await post(ServerRoutes.SmsScheduled.date, {
      date: dateStr,
    });
    if (result.error || (result.status && result.status !== 200)) {
      toast.error("שגיאה בבדיקת זמינות תזמון");
      return { free: false, alternatives: [] };
    }
    const body = result.data;
    const list = Array.isArray(body)
      ? body
      : Array.isArray(body?.data)
        ? body.data
        : [];
    const requests = (Array.isArray(list) ? list : [])
      .map((r) => {
        const t = r.scheduledTime;
        if (!t) return null;
        const hhmm = toIsraelHHmm(t);
        const [h, m] = hhmm.split(":").map(Number);
        return {
          minutes: h * 60 + m,
          platform: r.platform || "sms",
        };
      })
      .filter(Boolean);
    const [chosenH, chosenM] = chosenTimeStr.split(":").map(Number);
    const chosenMinutes = (chosenH ?? 0) * 60 + (chosenM ?? 0);
    const isAllowed = (candidateMinutes) => {
      if (requests.some((r) => r.minutes === candidateMinutes)) return false;
      if (
        platform === "whatsapp" &&
        requests.some(
          (r) =>
            r.minutes > candidateMinutes && r.minutes < candidateMinutes + 3,
        )
      ) {
        return false;
      }
      if (
        requests.some(
          (r) =>
            r.platform === "whatsapp" &&
            candidateMinutes > r.minutes &&
            candidateMinutes < r.minutes + 3,
        )
      ) {
        return false;
      }
      return true;
    };
    if (isAllowed(chosenMinutes)) return { free: true };

    const maxBack = 60;
    const maxForward = 60;
    const step = 1;
    let before = null;
    let after = null;
    for (let i = step; i <= maxBack; i += step) {
      const mm = chosenMinutes - i;
      if (mm < 0) break;
      const hh = Math.floor(mm / 60) % 24;
      const min = mm % 60;
      const key = `${String(hh).padStart(2, "0")}:${String(min).padStart(2, "0")}`;
      if (isAllowed(mm)) {
        before = key;
        break;
      }
    }
    for (let i = step; i <= maxForward; i += step) {
      const mm = chosenMinutes + i;
      if (mm > 23 * 60 + 59) break;
      const hh = Math.floor(mm / 60) % 24;
      const min = mm % 60;
      const key = `${String(hh).padStart(2, "0")}:${String(min).padStart(2, "0")}`;
      if (isAllowed(mm)) {
        after = key;
        break;
      }
    }
    const raw = [before, after].filter(Boolean);
    const alternatives = raw.filter((t) => isTimeValidForSchedule(dateStr, t));
    return { free: false, alternatives };
  };

  const doScheduleTodo = async (todo, dateStr, timeStr, platform) => {
    if (!todo?.uid) {
      toast.error("חסר מזהה משתמש למשימה. יש לרענן את העמוד ולנסות שוב.");
      return null;
    }
    const titlePart = todo.title.split(" ")[0];
    const requestType = scheduleTitleDict[titlePart] || "ac";
    const [y, mo, d] = dateStr.split("-").map(Number);
    const [h, min] = timeStr.split(":").map(Number);
    const localScheduled = new Date(y, mo - 1, d, h, min, 0, 0);
    const executionDate = localScheduled.toISOString();
    const res = await dispatch(
      sendSmsScheduled({
        uid: todo.uid,
        title: requestType,
        executionDate,
        platform,
      }),
    );
    if (res?.status === 409 || res?.error?.status === 409) {
      const body = res?.data ?? res?.error;
      const alternatives = body?.data?.alternatives ?? body?.alternatives ?? [];
      toast.warning(
        alternatives.length
          ? `הדקה תפוסה. שעות פנויות: ${alternatives.join(", ")}`
          : "הדקה תפוסה",
      );
      return { conflict: true, alternatives };
    }
    if (res?.error) {
      toast.error(res.error?.message || res.error || "שגיאה בתזמון");
      return null;
    }
    const id =
      res?.data?.data?.scheduledRequestId ?? res?.data?.scheduledRequestId;
    if (!id) {
      toast.error("לא התקבל מזהה תזמון");
      return null;
    }
    const scheduledAt = localScheduled.toISOString();
    await dispatch(edit(todo._id, { ScheduledRequestUid: id, scheduledAt }));
    toast.success("התזמון בוצע בהצלחה");
    return id;
  };

  const handleScheduleConfirm = async () => {
    if (!scheduleModalTodo) return;
    if (isTaskDatePassed(scheduleModalTodo.executionDate)) {
      toast.warning("לא ניתן לתזמן משימה שהתאריך שלה עבר");
      return;
    }
    const dateStr = getTaskDateStr(scheduleModalTodo.executionDate);
    const timeStr =
      scheduleTime.length === 5 ? scheduleTime : scheduleTime.slice(0, 5);
    if (!isTimeValidForSchedule(dateStr, timeStr)) {
      toast.warning("יש לבחור שעה שעוד לא חלפה, ולפחות 5 דקות מעכשיו");
      return;
    }
    setSchedulingTodoId(scheduleModalTodo._id);
    setScheduleLoading(true);
    try {
      const platform = scheduleModalTodo.title.includes("ווצאפ")
        ? "whatsapp"
        : "sms";
      const availability = await checkScheduleAvailability(
        scheduleModalTodo,
        timeStr,
        platform,
      );
      if (availability.free) {
        const ok = await doScheduleTodo(
          scheduleModalTodo,
          dateStr,
          timeStr,
          platform,
        );
        if (ok && typeof ok === "object" && ok.conflict) {
          setScheduleAlternatives(ok.alternatives ?? []);
          return;
        }
        if (ok) {
          setScheduleModalTodo(null);
          setScheduleAlternatives(null);
        }
        return;
      }
      setScheduleLoading(false);
      if (availability.alternatives && availability.alternatives.length >= 1) {
        setScheduleAlternatives(availability.alternatives);
      } else {
        toast.warning("לא נמצאה שעה פנויה קרובה");
      }
    } finally {
      setSchedulingTodoId(null);
      setScheduleLoading(false);
    }
  };

  const handleScheduleAlternative = async (timeStr) => {
    if (!scheduleModalTodo) return;
    if (isTaskDatePassed(scheduleModalTodo.executionDate)) {
      toast.warning("לא ניתן לתזמן משימה שהתאריך שלה עבר");
      return;
    }
    setSchedulingTodoId(scheduleModalTodo._id);
    setScheduleLoading(true);
    try {
      const dateStr = getTaskDateStr(scheduleModalTodo.executionDate);
      const platform = scheduleModalTodo.title.includes("ווצאפ")
        ? "whatsapp"
        : "sms";
      const ok = await doScheduleTodo(
        scheduleModalTodo,
        dateStr,
        timeStr,
        platform,
      );
      if (ok && typeof ok === "object" && ok.conflict) {
        setScheduleAlternatives(ok.alternatives ?? []);
        return;
      }
      if (ok) {
        setScheduleModalTodo(null);
        setScheduleAlternatives(null);
      }
    } finally {
      setSchedulingTodoId(null);
      setScheduleLoading(false);
    }
  };

  /** תזמון ישיר לפי שעה מ־tizmunTime + תאריך מהמשימה */
  const handleScheduleDirect = async (todo) => {
    if (isTaskDatePassed(todo.executionDate)) {
      toast.warning("לא ניתן לתזמן משימה שהתאריך שלה עבר");
      return;
    }
    if (!tizmunTime || !tizmunTime.includes(":")) {
      toast.warning("יש לבחור שעה בשדה התזמון");
      return;
    }
    const dateStr = getTaskDateStr(todo.executionDate);
    const timeStr =
      tizmunTime.length >= 5 ? tizmunTime.slice(0, 5) : tizmunTime + ":00";
    if (!isTimeValidForSchedule(dateStr, timeStr)) {
      toast.warning("יש לבחור שעה שעוד לא חלפה, ולפחות 5 דקות מעכשיו");
      return;
    }
    setSchedulingTodoId(todo._id);
    setScheduleLoading(true);
    try {
      const platform = todo.title.includes("ווצאפ") ? "whatsapp" : "sms";
      const availability = await checkScheduleAvailability(
        todo,
        timeStr,
        platform,
      );
      if (availability.free) {
        const ok = await doScheduleTodo(todo, dateStr, timeStr, platform);
        if (ok && typeof ok === "object" && ok.conflict) {
          setScheduleModalTodo(todo);
          setScheduleAlternatives(ok.alternatives ?? []);
          setScheduleTime(
            (ok.alternatives && ok.alternatives[0]) || timeStr.slice(0, 5),
          );
        }
      } else {
        setScheduleLoading(false);
        toast.warning(
          availability.alternatives?.length
            ? `השעה תפוסה. שעות פנויות: ${availability.alternatives.join(", ")}`
            : "השעה תפוסה ולא נמצאה שעה פנויה קרובה",
        );
      }
    } finally {
      setSchedulingTodoId(null);
      setScheduleLoading(false);
    }
  };

  const handleCancelScheduleConfirm = async () => {
    if (!cancelScheduleTodo) return;
    setSchedulingTodoId(cancelScheduleTodo._id);
    setScheduleLoading(true);
    try {
      const { data, error, status } = await post(
        ServerRoutes.SmsScheduled.cancelById,
        {
          taskId: cancelScheduleTodo.ScheduledRequestUid,
        },
      );
      if (status !== 200 || error) {
        toast.error(error?.message || error || "שגיאה בביטול התזמון");
        setCancelScheduleTodo(null);
        return;
      }
      dispatch(
        edit(cancelScheduleTodo._id, {
          ScheduledRequestUid: null,
          scheduledAt: null,
        }),
      );
      toast.success("התזמון בוטל");
      setCancelScheduleTodo(null);
    } finally {
      setSchedulingTodoId(null);
      setScheduleLoading(false);
    }
  };

  const handleShowOccupiedSlots0809 = async () => {
    const dateStr = new Date().toLocaleDateString("en-CA", {
      timeZone: "Asia/Jerusalem",
    });
    setLoadingOccupiedSlots(true);
    setShowOccupiedSlotsModal(true);
    try {
      const { data } = await post(ServerRoutes.SmsScheduled.date, {
        date: dateStr,
      });
      const list = data?.data ?? data ?? [];
      const occupied = new Set();
      (Array.isArray(list) ? list : []).forEach((r) => {
        const t = r.scheduledTime;
        if (!t) return;
        const hhmm = toIsraelHHmm(t);
        const [h, m] = hhmm.split(":").map(Number);
        if (h === 8 && m >= 0 && m <= 59) occupied.add(hhmm);
      });
      const sorted = Array.from(occupied).sort((a, b) => a.localeCompare(b));
      setOccupiedSlots0809(sorted);
    } catch (e) {
      toast.error("שגיאה בטעינת הסלוטים");
      setOccupiedSlots0809([]);
    }
    setLoadingOccupiedSlots(false);
  };

  const handleSetDone = async (id, done) => {
    let talTime = "";
    if (done && tizmunTime && tizmunTime.includes(":")) {
      const parts = tizmunTime.split(":");
      talTime =
        parts.length >= 2
          ? `${String(parts[0]).padStart(2, "0")}:${String(parts[1]).padStart(2, "0")}`.slice(
              0,
              5,
            )
          : tizmunTime.length >= 5
            ? tizmunTime.slice(0, 5)
            : "";
    }
    const body = {
      done,
      tal: done ? talTime : "",
    };
    dispatch(setDone(id, body)).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
      } else toast.error(res.payload?.error);
    });
  };

  const getTomorrowDate = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow.toISOString().slice(0, 10);
  };

  const handleFetchScheduled = (date = null) => {
    setLoadingScheduled(true);
    dispatch(
      fetchScheduledTasks({
        date: date || new Date().toISOString().slice(0, 10),
      }),
    ).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      else {
        const arr = Array.isArray(res.payload?.data)
          ? res.payload.data
          : Array.isArray(res.payload)
            ? res.payload
            : [];

        // מיון המשימות לפי שעת הביצוע (scheduledTime)
        arr.sort(
          (a, b) => new Date(a.scheduledTime) - new Date(b.scheduledTime),
        );

        setScheduledTasks(arr);
        setShowScheduledModal(true);
      }
      setLoadingScheduled(false);
    });
  };

  useEffect(() => {
    handleGetAll();
    return () => {
      dispatch(cleanAll());
    };
  }, []);

  let todosArray = useMemo(() => {
    let today = new Date();
    let arr = [];
    let sortedArray = [];
    if (Object.keys(todos).length > 0) {
      for (const [key, value] of Object.entries(todos)) sortedArray.push(value);
      sortedArray.sort(
        (a, b) => new Date(a["executionDate"]) - new Date(b["executionDate"]),
      );
      for (let i = 0; i < sortedArray.length; i++)
        if (sortedArray[i].title.includes(category))
          arr.push(
            <TodoCard
              borderL={
                sortedArray[i].tal !== "" ? "rgba(177, 141, 224, 0.9)" : "none"
              }
              style={{
                borderRight:
                  days(new Date(), new Date(sortedArray[i].executionDate)) == 0
                    ? "5px solid #7b96c4"
                    : "none",
                cursor: "text",
              }}
              key={i}
            >
              <div
                onContextMenu={() => setShowTals(sortedArray[i].uid)}
                onClick={() => handleCountNotAnswered(sortedArray[i].uid)}
              >
                {sortedArray[i].title}
              </div>
              <div>
                <div style={{ fontSize: "13px" }}>
                  {sortedArray[i].executionDate
                    .replace(/T.*/, "")
                    .split("-")
                    .reverse()
                    .join("/")}
                </div>
                <div onClick={() => toast.info(sortedArray[i].tal || "")}>
                  {sortedArray[i].company}
                </div>
              </div>
              {sortedArray[i].title.split(" ")[0] === "הסדרת" && (
                <GenericDiv
                  onClick={() => handleGetIsPaid(sortedArray[i].uid)}
                  background={"rgba(123,150,196,0.95)"}
                  style={{ margin: "0 20px", padding: "4px 4px" }}
                >
                  בדיקה
                </GenericDiv>
              )}

              {(sortedArray[i].title.split(" ")[0] === "לבדוק" ||
                sortedArray[i].title.split(" ")[0] === "לוודא") && (
                <GenericDiv
                  onClick={() => handleCheck1(sortedArray[i].uid)}
                  background={"rgba(123,150,196,0.95)"}
                  style={{ margin: "0 20px", padding: "4px 4px" }}
                >
                  בדיקה
                </GenericDiv>
              )}

              {["הודעה", "ווצאפ", "תזכורת", "תודה", "קדם"].includes(
                sortedArray[i].title.split(" ")[0],
              ) && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    flexWrap: "wrap",
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  {sortedArray[i].done ? (
                    <span style={{ fontSize: "13px", color: "#2e7d32" }}>
                      נשלח בהצלחה
                    </span>
                  ) : sortedArray[i].ScheduledRequestUid ? (
                    sortedArray[i].scheduleStatus === "sent" ? (
                      <span style={{ fontSize: "13px", color: "#2e7d32" }}>
                        נשלח בהצלחה
                      </span>
                    ) : sortedArray[i].scheduleStatus === "failed" ? (
                      <span style={{ fontSize: "13px", color: "#c62828" }}>
                        נכשל
                        {sortedArray[i].scheduleErrorMessage
                          ? ` – ${sortedArray[i].scheduleErrorMessage}`
                          : ""}
                      </span>
                    ) : (
                      <>
                        <MediumFont style={{ fontSize: "13px" }}>
                          {sortedArray[i].scheduledAt
                            ? toIsraelHHmm(sortedArray[i].scheduledAt)
                            : "מתוזמן"}
                        </MediumFont>
                        <GenericDiv
                          onClick={() => setCancelScheduleTodo(sortedArray[i])}
                          background={"#c62828"}
                          style={{
                            padding: "4px 8px",
                            borderRadius: "5px",
                            cursor: "pointer",
                            color: "#fff",
                            fontSize: "13px",
                          }}
                        >
                          ביטול תזמון
                        </GenericDiv>
                      </>
                    )
                  ) : isTaskDatePassed(sortedArray[i].executionDate) ? (
                    <span style={{ fontSize: "13px", color: "#9e9e9e" }}>
                      תאריך עבר
                    </span>
                  ) : (
                    <GenericDiv
                      onClick={() => {
                        if (tizmun) {
                          handleScheduleDirect(sortedArray[i]);
                        } else {
                          setScheduleModalTodo(sortedArray[i]);
                          setScheduleTime(
                            tizmunTime && tizmunTime.length >= 5
                              ? tizmunTime.slice(0, 5)
                              : getDefaultScheduleTime(),
                          );
                          setScheduleAlternatives(null);
                        }
                      }}
                      background={"#7b96c4"}
                      style={{
                        padding: "4px 10px",
                        borderRadius: "5px",
                        cursor:
                          scheduleLoading &&
                          schedulingTodoId === sortedArray[i]._id
                            ? "wait"
                            : "pointer",
                        color: "#fff",
                        fontSize: "13px",
                      }}
                    >
                      {scheduleLoading &&
                      schedulingTodoId === sortedArray[i]._id
                        ? "..."
                        : "תזמון"}
                    </GenericDiv>
                  )}
                  <div
                    style={{ width: "min-content" }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <Switcher
                      onOfColor={"#C0C0C0"}
                      color={"#2e7d32"}
                      checked={sortedArray[i].done}
                      onChange={() =>
                        handleSetDone(sortedArray[i]._id, !sortedArray[i].done)
                      }
                    />
                  </div>
                </div>
              )}

              {sortedArray[i].title.split(" ")[0] !== "הסדרת" &&
                sortedArray[i].title.split(" ")[0] !== "לבדוק" &&
                sortedArray[i].title.split(" ")[0] !== "לוודא" &&
                sortedArray[i].done === false &&
                !sortedArray[i].ScheduledRequestUid &&
                !isTaskDatePassed(sortedArray[i].executionDate) && (
                  <img
                    onClick={(e) => {
                      e.stopPropagation();
                      if (tizmun)
                        handleSendSmsAndWhatsappScheduled(
                          sortedArray[i].uid,
                          sortedArray[i].title.split(" ")[0],
                          sortedArray[i].executionDate,
                        );
                      else
                        handleSendSms(
                          sortedArray[i].uid,
                          sortedArray[i].title.split(" ")[0],
                          sortedArray[i].executionDate,
                        );
                    }}
                    src={sms}
                    alt="sms"
                    style={{ width: "23px", cursor: "pointer" }}
                  />
                )}
              {sortedArray[i].title.split(" ")[0] !== "הסדרת" &&
                sortedArray[i].title.split(" ")[0] !== "לבדוק" &&
                sortedArray[i].title.split(" ")[0] !== "לוודא" &&
                sortedArray[i].title.split(" ")[0] !== "קדם" &&
                sortedArray[i].title.split(" ")[0] !== "תודה" &&
                sortedArray[i].title.split(" ")[0] !== "ערב" &&
                sortedArray[i].done === false &&
                !sortedArray[i].ScheduledRequestUid &&
                !isTaskDatePassed(sortedArray[i].executionDate) && (
                  <img
                    onClick={(e) => {
                      e.stopPropagation();
                      if (tizmun)
                        handleSendSmsAndWhatsappScheduled(
                          sortedArray[i].uid,
                          sortedArray[i].title.split(" ")[0],
                          sortedArray[i].executionDate,
                          "whatsapp",
                        );
                      else
                        handleSendWhatsapp(
                          sortedArray[i].uid,
                          sortedArray[i].title.split(" ")[0],
                          sortedArray[i].executionDate,
                        );
                    }}
                    src={whatsapp}
                    alt="whatsapp"
                    style={{ width: "28px", cursor: "pointer" }}
                  />
                )}

              {!["הודעה", "ווצאפ", "תזכורת", "תודה", "קדם"].includes(
                sortedArray[i].title.split(" ")[0],
              ) && (
                <div
                  style={{ width: "min-content" }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <Switcher
                    onOfColor={"#C0C0C0"}
                    color={"#7b96c4"}
                    checked={
                      sortedArray[i].title.split(" ")[0] === "שיחה"
                        ? sortedArray[i].belongs
                        : sortedArray[i].done
                    }
                    onChange={() => {
                      if (sortedArray[i].title.split(" ")[0] === "שיחה")
                        handleSetBelogs(
                          sortedArray[i]._id,
                          !sortedArray[i].belongs,
                        );
                      else
                        handleSetDone(sortedArray[i]._id, !sortedArray[i].done);
                    }}
                  />
                </div>
              )}
            </TodoCard>,
          );
    }
    return arr;
  }, [todos, category, tizmun, tizmunTime]);

  const formatDateTime = (dateString) => {
    const d = new Date(dateString);
    return `${String(d.getDate()).padStart(2, "0")}/${String(
      d.getMonth() + 1,
    ).padStart(2, "0")}/${d.getFullYear()} - ${String(d.getHours()).padStart(
      2,
      "0",
    )}:${String(d.getMinutes()).padStart(2, "0")}`;
  };

  // Delete a single scheduled task
  const handleDeleteScheduled = (taskId) => {
    setLoadingScheduled(true);
    dispatch(deleteScheduledTask(taskId))
      .then((res) => {
        if (res.payload.error) toast.error(res.payload.error.message);
        else {
          // If we got the taskId back, it means success
          setScheduledTasks((prev) => prev.filter((t) => t._id !== taskId));
          toast.success("התזמון נמחק בהצלחה");
        }
      })
      .catch((error) => {
        console.error("Error deleting scheduled task:", error);
        toast.error("שגיאה במחיקת התזמון");
      })
      .finally(() => {
        setLoadingScheduled(false);
      });
  };

  // Update scheduled task time
  const handleUpdateScheduled = (taskId, newScheduledTime) => {
    setLoadingScheduled(true);
    dispatch(updateScheduledTask({ taskId, scheduledTime: newScheduledTime }))
      .then((res) => {
        if (res.payload?.error) toast.error(res.payload.error);
        else {
          // Update the task in the local state
          // setScheduledTasks((prev) =>
          //   prev.map((t) =>
          //     t._id === taskId ? { ...t, scheduledTime: newScheduledTime } : t
          //   )
          // );
          toast.success("התזמון עודכן בהצלחה");
          setShowEditModal(false);
          setEditTarget(null);
          setEditScheduledTime("");
        }
      })
      .catch((error) => {
        console.error("Error updating scheduled task:", error);
        toast.error("שגיאה בעדכון התזמון");
      })
      .finally(() => {
        setLoadingScheduled(false);
      });
  };

  // Bulk delete scheduled tasks before a date
  const handleBulkDelete = async () => {
    setLoadingScheduled(true);
    dispatch(deleteOldScheduledTasks(bulkDeleteDate)).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      else {
        toast.success(
          res.payload?.deletedCount
            ? `נמחקו ${res.payload.deletedCount} תזמונים ישנים`
            : "הפעולה בוצעה בהצלחה",
        );
        setShowScheduledModal(false);
      }
      setLoadingScheduled(false);
    });
  };

  return (
    <div
      style={{
        width: "100%",
        height: `${window.screen.availHeight}px`,
      }}
    >
      <BottomMenu
        data={[
          <img
            key={1}
            src={refresh}
            alt="refresh"
            style={{ width: "23px", padding: "10px 0", cursor: "pointer" }}
            onClick={handleGetAll}
          />,
          <img
            key={2}
            src={tools}
            alt="tools"
            style={{ width: "31px", padding: "10px 0", cursor: "pointer" }}
            onClick={() => setShowMenu(true)}
          />,
          <img
            key={3}
            src={logout}
            alt="logout"
            style={{ width: "31px", padding: "10px 0", cursor: "pointer" }}
            onClick={() => setShowLogout(true)}
          />,
        ]}
      />
      <div
        style={{
          height: "170px",
          width: "100%",
          alignItems: "center",
          justifyContent: "center",
          position: "fixed",
          marginBottom: "100px",
          zIndex: 1,
          background: "white",
          boxShadow: "0 2px 4px #f2f2f2",
        }}
      >
        <FlexRowBetween>
          <FilterBar
            color={"#5377bb"}
            padding={"7px 12px"}
            data={categories}
            setProperty={setCategory}
            property={category}
          />
        </FlexRowBetween>
        <FlexRowBetween
          style={{
            justifyContent: "center",
            alignItems: "center",
            marginTop: "15px",
          }}
        >
          {tizmun ? (
            <>
              <input
                type="time"
                value={tizmunTime}
                onChange={(e) => setTizmunTime(e.target.value)}
                style={{
                  padding: "5px 8px",
                  border: "2px solid #f2f2f2",
                  marginLeft: "10px",
                }}
              />
              <button
                type="button"
                onClick={handleShowOccupiedSlots0809}
                disabled={loadingOccupiedSlots}
                style={{
                  marginRight: "12px",
                  marginLeft: "12px",
                  padding: "6px 12px",
                  fontSize: "13px",
                  background: "#7b96c4",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                  cursor: loadingOccupiedSlots ? "wait" : "pointer",
                }}
              >
                {loadingOccupiedSlots ? "טוען..." : "תפוסים"}
              </button>
            </>
          ) : null}
          <div style={{ marginLeft: "20px" }}>תזמון</div>
          <Switcher
            onOfColor={"#C0C0C0"}
            color={"#7b96c4"}
            checked={tizmun}
            onChange={() => setTizmun(!tizmun)}
          />
          <div style={{ marginRight: "20px" }}>עכשיו</div>
        </FlexRowBetween>
        {tizmun ? (
          <FlexRowBetween
            style={{
              justifyContent: "center",
              alignItems: "center",
              marginTop: "15px",
            }}
          >
            <button
              onClick={() => setNow()}
              disabled={loadingScheduled}
              style={{
                marginLeft: 10,
                padding: "6px 12px",
                background: "#c1793e",
                color: "white",
                border: "none",
                borderRadius: 4,
                cursor: "pointer",
              }}
            >
              Now
            </button>
            <button
              onClick={() => addMinutes(5)}
              disabled={loadingScheduled}
              style={{
                marginLeft: 10,
                padding: "6px 12px",
                background: "#59a844",
                color: "white",
                border: "none",
                borderRadius: 4,
                cursor: "pointer",
              }}
            >
              +5
            </button>
            <button
              onClick={() => addMinutes(2)}
              disabled={loadingScheduled}
              style={{
                marginLeft: 10,
                padding: "6px 12px",
                background: "#59a844",
                color: "white",
                border: "none",
                borderRadius: 4,
                cursor: "pointer",
              }}
            >
              +2
            </button>
            <button
              onClick={() => addMinutes(1)}
              disabled={loadingScheduled}
              style={{
                marginLeft: 10,
                padding: "6px 12px",
                background: "#59a844",
                color: "white",
                border: "none",
                borderRadius: 4,
                cursor: "pointer",
              }}
            >
              +1
            </button>
            <button
              onClick={() => handleFetchScheduled()}
              disabled={loadingScheduled}
              style={{
                marginLeft: 10,
                padding: "6px 12px",
                background: "#5377bb",
                color: "white",
                border: "none",
                borderRadius: 4,
                cursor: "pointer",
              }}
            >
              {loadingScheduled ? "טוען.." : "היום"}
            </button>
            <button
              onClick={() => handleFetchScheduled(getTomorrowDate())}
              disabled={loadingScheduled}
              style={{
                margin: "0px 15px",
                padding: "6px 12px",
                background: "#5377bb",
                color: "white",
                border: "none",
                borderRadius: 4,
                cursor: "pointer",
              }}
            >
              {loadingScheduled ? "טוען.." : "מחר"}
            </button>
            <div style={{ marginLeft: 10 }}>
              <input
                type="date"
                value={bulkDeleteDate}
                onChange={(e) => setBulkDeleteDate(e.target.value)}
                style={{ marginRight: 6 }}
              />
              <button
                onClick={() => setShowBulkDeleteModal(true)}
                disabled={!bulkDeleteDate}
                style={{
                  padding: "6px 12px",
                  background: "#b30000",
                  color: "white",
                  border: "none",
                  borderRadius: 4,
                  cursor: "pointer",
                }}
              >
                מחק ישנים
              </button>
            </div>
          </FlexRowBetween>
        ) : null}
      </div>
      <div style={{ height: "200px" }} />
      <ListHolder>{todosArray}</ListHolder>
      <div style={{ height: "100px" }} />

      {showLoading && <FilledLoading />}
      {dataLoading && <OpacityLoading />}
      {showLogout && (
        <GenericModal
          init={setShowLogout}
          div={<LogoutSpecipic init={setShowLogout} />}
        />
      )}

      {firstCall && (
        <GenericModal
          init={setFirstCall}
          div={
            <YesNoModal
              title={"רישום כמות שיחות"}
              body={`האם את/ה בטוח/ה שברצונך לרשום ${firstCall.restRecordsAtFirstCall} שיחות לאירוע זה?`}
              no={setFirstCall}
              yes={handleSetFirstCall}
            />
          }
        />
      )}

      {showTals && (
        <GenericModal
          init={setShowTals}
          div={<TalsTodos init={setShowTals} uid={showTals} />}
        />
      )}

      {showMenu && (
        <GenericModal
          init={setShowMenu}
          div={
            <ToolsOptions
              data={[
                <TextWithPic
                  key={1}
                  onClick={() => history.push(ClientRoutes.Admin.main)}
                >
                  ראשי
                </TextWithPic>,
                // <TextWithPic
                //   onClick={() => history.push(ClientRoutes.Admin.todos)}
                //   key={2}
                // >
                //   משימות
                // </TextWithPic>,
              ]}
            />
          }
        />
      )}

      {/* Scheduled Tasks Modal */}
      {showScheduledModal && (
        <GenericModal
          init={setShowScheduledModal}
          div={
            <div
              style={{
                padding: 16,
                maxWidth: "70vw",
                maxHeight: "70vh",
                overflowY: "auto",
                background: "white",
                boxShadow:
                  "0 4px 24px rgba(0,0,0,0.18), 0 1.5px 6px rgba(0,0,0,0.10)",
                borderRadius: 12,
                margin: "auto",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <h4>תוצאות:</h4>
              <div>
                {scheduledTasks.length === 0 && <div>אין תזמונים להיום</div>}
                {scheduledTasks.map((task, idx) => (
                  <React.Fragment key={task._id || task.id}>
                    <div
                      style={{
                        padding: "8px 0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <span>
                        משתמש: {task.userId?.phone}, סוג: {task.requestType},
                        שעה: {formatDateTime(task.scheduledTime)}, סטטוס:
                        <span
                          style={{
                            background:
                              task.status === "failed"
                                ? "rgba(255,0,0,0.15)"
                                : task.status === "sent" ||
                                    task.status === "completed"
                                  ? "rgba(0,128,0,0.15)"
                                  : "rgba(0,0,0,0.05)",
                            color:
                              task.status === "failed"
                                ? "#b30000"
                                : task.status === "sent" ||
                                    task.status === "completed"
                                  ? "#006600"
                                  : "inherit",
                            padding: "2px 8px",
                            borderRadius: 6,
                            fontWeight: 500,
                            marginRight: 4,
                            opacity: 0.85,
                            display: "inline-block",
                          }}
                        >
                          {task.status === "failed" && task.errorMessage
                            ? `failed - ${task.errorMessage}`
                            : task.status}
                        </span>
                      </span>
                      <div style={{ display: "flex", gap: "8px" }}>
                        <button
                          onClick={() => {
                            setEditTarget(task);
                            setEditScheduledTime(
                              new Date(task.scheduledTime)
                                .toISOString()
                                .slice(0, 19),
                            );
                            setShowEditModal(true);
                          }}
                          style={{
                            background: "#5377bb",
                            color: "white",
                            border: "none",
                            borderRadius: 4,
                            padding: "2px 8px",
                            cursor: "pointer",
                          }}
                        >
                          ערוך
                        </button>
                        <button
                          onClick={() => {
                            setDeleteTarget(task);
                            setShowDeleteModal(true);
                          }}
                          style={{
                            background: "#b30000",
                            color: "white",
                            border: "none",
                            borderRadius: 4,
                            padding: "2px 8px",
                            cursor: "pointer",
                          }}
                        >
                          מחק
                        </button>
                      </div>
                    </div>
                    {idx < scheduledTasks.length - 1 && (
                      <hr
                        style={{
                          border: "none",
                          borderTop: "1px solid #726f6f",
                          margin: 0,
                        }}
                      />
                    )}
                  </React.Fragment>
                ))}
              </div>
              <button
                onClick={() => setShowScheduledModal(false)}
                style={{ marginTop: 12 }}
              >
                סגור
              </button>
            </div>
          }
        />
      )}
      {showDeleteModal && deleteTarget && (
        <GenericModal
          init={() => {
            setShowDeleteModal(false);
            setDeleteTarget(null);
          }}
          div={
            <YesNoModal
              title={"מחיקת תזמון"}
              body={"האם אתה בטוח שברצונך למחוק תזמון זה?"}
              no={() => {
                setShowDeleteModal(false);
                setDeleteTarget(null);
              }}
              yes={() => {
                handleDeleteScheduled(deleteTarget._id);
                setShowDeleteModal(false);
                setDeleteTarget(null);
              }}
            />
          }
        />
      )}
      {showEditModal && editTarget && (
        <GenericModal
          init={() => {
            setShowEditModal(false);
            setEditTarget(null);
            setEditScheduledTime("");
          }}
          div={
            <div
              style={{
                padding: 20,
                background: "white",
                borderRadius: 8,
                minWidth: "300px",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <h4>עריכת תזמון</h4>
              <div style={{ marginBottom: 16 }}>
                <div style={{ marginBottom: 8 }}>
                  <strong>משתמש:</strong> {editTarget.userId?.phone}
                </div>
                <div style={{ marginBottom: 8 }}>
                  <strong>סוג:</strong> {editTarget.requestType}
                </div>
                <div style={{ marginBottom: 16 }}>
                  <strong>שעה נוכחית:</strong>{" "}
                  {formatDateTime(editTarget.scheduledTime)}
                </div>
                <div>
                  <button
                    onClick={() => setNow2()}
                    disabled={loadingScheduled}
                    style={{
                      marginLeft: 10,
                      padding: "6px 12px",
                      background: "#c1793e",
                      color: "white",
                      border: "none",
                      borderRadius: 4,
                      cursor: "pointer",
                    }}
                  >
                    Now
                  </button>
                  <label style={{ display: "block", marginBottom: 4 }}>
                    <strong>שעה חדשה:</strong>
                  </label>
                  <input
                    type="text"
                    value={editScheduledTime}
                    onChange={(e) => setEditScheduledTime(e.target.value)}
                    placeholder="2025-07-01T11:31:00"
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: "1px solid #ccc",
                      borderRadius: 4,
                    }}
                  />
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#666",
                      marginTop: "4px",
                    }}
                  >
                    פורמט: YYYY-MM-DDTHH:MM:SS
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "8px",
                  justifyContent: "flex-end",
                }}
              >
                <button
                  onClick={() => {
                    setShowEditModal(false);
                    setEditTarget(null);
                    setEditScheduledTime("");
                  }}
                  style={{
                    padding: "8px 16px",
                    background: "#ccc",
                    color: "black",
                    border: "none",
                    borderRadius: 4,
                    cursor: "pointer",
                  }}
                >
                  ביטול
                </button>
                <button
                  onClick={() => {
                    if (editScheduledTime) {
                      handleUpdateScheduled(editTarget._id, editScheduledTime);
                    } else {
                      toast.warning("אנא בחר שעה חדשה");
                    }
                  }}
                  disabled={loadingScheduled}
                  style={{
                    padding: "8px 16px",
                    background: "#5377bb",
                    color: "white",
                    border: "none",
                    borderRadius: 4,
                    cursor: "pointer",
                  }}
                >
                  {loadingScheduled ? "מעדכן..." : "עדכן"}
                </button>
              </div>
            </div>
          }
        />
      )}
      {showBulkDeleteModal && (
        <GenericModal
          init={() => setShowBulkDeleteModal(false)}
          div={
            <YesNoModal
              title={"מחיקת תזמונים ישנים"}
              body={`האם אתה בטוח שברצונך למחוק את כל התזמונים עד לתאריך ${bulkDeleteDate}?`}
              no={() => setShowBulkDeleteModal(false)}
              yes={() => {
                handleBulkDelete();
                setShowBulkDeleteModal(false);
              }}
            />
          }
        />
      )}

      {scheduleModalTodo && (
        <GenericModal
          init={() => {
            setScheduleModalTodo(null);
            setScheduleAlternatives(null);
          }}
          div={
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                padding: "20px",
                minWidth: "280px",
                background: "#fff",
                borderRadius: "12px",
                border: "2px solid #7b96c4",
                boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
              }}
            >
              <BoldFont style={{ marginBottom: "12px", display: "block" }}>
                בחירת שעת תזמון
              </BoldFont>
              <div style={{ fontSize: "14px", marginBottom: "8px" }}>
                תאריך:{" "}
                {scheduleModalTodo.executionDate
                  ?.replace?.(/T.*/, "")
                  ?.split("-")
                  ?.reverse()
                  ?.join("/")}
              </div>
              {!scheduleAlternatives ? (
                <>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "4px",
                      fontSize: "14px",
                    }}
                  >
                    שעה
                  </label>
                  <input
                    type="time"
                    value={scheduleTime}
                    min={
                      scheduleModalTodo
                        ? getMinScheduleTime(
                            getTaskDateStr(scheduleModalTodo.executionDate),
                          )
                        : "00:00"
                    }
                    onChange={(e) => setScheduleTime(e.target.value)}
                    style={{
                      marginBottom: "16px",
                      padding: "8px",
                      fontSize: "16px",
                    }}
                  />
                  <FlexRowBetween style={{ gap: "8px" }}>
                    <button
                      type="button"
                      onClick={handleScheduleConfirm}
                      disabled={scheduleLoading}
                      style={{
                        padding: "8px 16px",
                        background: "#7b96c4",
                        color: "#fff",
                        border: "none",
                        borderRadius: "5px",
                        cursor: scheduleLoading ? "wait" : "pointer",
                      }}
                    >
                      {scheduleLoading ? "בודק..." : "אשר"}
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setScheduleModalTodo(null);
                        setScheduleAlternatives(null);
                      }}
                      style={{
                        padding: "8px 16px",
                        background: "#e0e0e0",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                      }}
                    >
                      ביטול
                    </button>
                  </FlexRowBetween>
                </>
              ) : (
                <>
                  <MediumFont style={{ marginBottom: "12px" }}>
                    השעה שבחרת תפוסה אבל פנוי:
                  </MediumFont>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    {scheduleAlternatives.map((t) => (
                      <button
                        key={t}
                        type="button"
                        onClick={() => handleScheduleAlternative(t)}
                        disabled={scheduleLoading}
                        style={{
                          padding: "10px",
                          background: "#7b96c4",
                          color: "#fff",
                          border: "none",
                          borderRadius: "5px",
                          cursor: scheduleLoading ? "wait" : "pointer",
                        }}
                      >
                        {t}
                      </button>
                    ))}
                  </div>
                  <button
                    type="button"
                    onClick={() => setScheduleAlternatives(null)}
                    style={{
                      marginTop: "12px",
                      padding: "6px 12px",
                      background: "transparent",
                      border: "1px solid #999",
                      borderRadius: "5px",
                      cursor: "pointer",
                      fontSize: "13px",
                    }}
                  >
                    חזרה לבחירת שעה
                  </button>
                </>
              )}
            </div>
          }
        />
      )}

      {cancelScheduleTodo && (
        <GenericModal
          init={() => setCancelScheduleTodo(null)}
          div={
            <YesNoModal
              title="ביטול תזמון"
              body="האם אתה בטוח שברצונך למחוק את התזמון?"
              yes={() => handleCancelScheduleConfirm()}
              no={() => setCancelScheduleTodo(null)}
              yesText="מחק"
              noText="ביטול"
              yesColor="#c62828"
            />
          }
        />
      )}

      {showOccupiedSlotsModal && (
        <GenericModal
          init={() => setShowOccupiedSlotsModal(false)}
          div={
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                padding: "20px",
                minWidth: "280px",
                maxWidth: "90vw",
                maxHeight: "70vh",
                overflow: "auto",
                background: "#fff",
                borderRadius: "12px",
                border: "2px solid #7b96c4",
                boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
              }}
            >
              <BoldFont style={{ marginBottom: "12px", display: "block" }}>
                סלוטים תפוסים 08:00–09:00
              </BoldFont>
              <div
                style={{
                  fontSize: "14px",
                  marginBottom: "12px",
                  color: "#555",
                }}
              >
                תאריך:{" "}
                {new Date().toLocaleDateString("he-IL", {
                  timeZone: "Asia/Jerusalem",
                })}
              </div>
              {loadingOccupiedSlots ? (
                <div style={{ padding: "12px" }}>טוען...</div>
              ) : occupiedSlots0809.length === 0 ? (
                <div style={{ padding: "12px", color: "#2e7d32" }}>
                  אין סלוטים תפוסים בטווח 08:00–09:00
                </div>
              ) : (
                <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                  {occupiedSlots0809.map((slot) => (
                    <span
                      key={slot}
                      style={{
                        padding: "4px 10px",
                        background: "#e8e8e8",
                        borderRadius: "6px",
                        fontSize: "13px",
                      }}
                    >
                      {slot}
                    </span>
                  ))}
                </div>
              )}
              <button
                type="button"
                onClick={() => setShowOccupiedSlotsModal(false)}
                style={{
                  marginTop: "16px",
                  padding: "8px 16px",
                  background: "#7b96c4",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                סגור
              </button>
            </div>
          }
        />
      )}
    </div>
  );
};

export default AdminTodos;
